import { z } from 'zod'
import type { BlockConfig } from './blockConfig'

// A "linked" sub-workflow block mirrors a main-workflow block: it stores only this back-reference
// and no config of its own, so it can't drift from the block it mirrors. Its real BlockConfig is
// resolved from the linked main block at request creation (see resolveSubWorkflows).
export const LinkedBlockConfigSchema = z.object({
  payload: z.object({ linkedMainNodeId: z.string(), subWorkflowId: z.string().optional() }),
})

export type LinkedBlockConfig = z.infer<typeof LinkedBlockConfigSchema>

export const isLinkedBlockConfig = (config: BlockConfig | LinkedBlockConfig | undefined | null): config is LinkedBlockConfig =>
  LinkedBlockConfigSchema.safeParse(config).success
